import React, { useEffect } from 'react';
import { Siren } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

/**
 * EmergencyButton — one-tap navigation to the shared /get-help page.
 *
 * Sep 2026 rewrite (Tudor spec, Fix 2):
 *   • The button no longer fetches or caches resources locally.  It just
 *     opens /get-help, which reads the single 16-country directory served
 *     by /api/support-directory (routes/quick_checkin.py).
 *   • On mount we sweep out the retired `emergency_resources_v1_*` and
 *     `user_country_code` localStorage keys from any user's browser so
 *     the old cached list disappears without waiting for cache-eviction.
 */
export default function EmergencyButton() {
  const navigate = useNavigate();

  // One-time client-side purge of the retired cache.
  useEffect(() => {
    try {
      const drop = [];
      for (let i = 0; i < localStorage.length; i++) {
        const k = localStorage.key(i);
        if (k && (k.startsWith('emergency_resources_v1_') || k === 'user_country_code')) {
          drop.push(k);
        }
      }
      drop.forEach((k) => localStorage.removeItem(k));
    } catch (_) { /* private-mode / storage-disabled: nothing to purge */ }
  }, []);

  return (
    <button
      onClick={() => navigate('/get-help')}
      className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-rose-600 hover:bg-rose-700 text-white text-sm font-bold shadow-sm"
      data-testid="emergency-help-button"
      aria-label="Get help now"
    >
      <Siren className="w-4 h-4" />
      Get help now
    </button>
  );
}
